export const tableStyles = {
  tableContainer: {
    sx: {
      width: '100%',
      height: '100%',
      overflow: 'auto',
      '& thead': {
        position: 'sticky',
        top: 0,
        backgroundColor: '#F2F2F2',
        zIndex: 2,
      },
    },
  },
  tablePaper: {
    elevation: 0,
    sx: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '8px',
      border: '1px solid #e0e0e0',
      position: 'relative',
      width: '100%'
    },
  },
  topToolbar: {
    sx: {
      position: 'sticky',
      top: 0,
      backgroundColor: '#F2F2F2',
      zIndex: 3,
      borderBottom: '1px solid #e0e0e0',
    },
  },
  tableHead: {
    sx: {
      position: 'sticky',
      top: '64px',
      backgroundColor: '#F2F2F2',
      zIndex: 2,
      '& th': {
        position: 'sticky',
        backgroundColor: '#F2F2F2',
        borderBottom: '1px solid #e0e0e0',
      },
    },
  },
  tableHeadCell: {
    sx: {
      position: 'sticky',
      backgroundColor: '#F2F2F2',
      zIndex: 2,
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'unset',
      '& .MuiTableSortLabel-root': {
        width: '100%',
      },
    },
  },
  bottomToolbar: {
    sx: {
      position: 'sticky',
      bottom: 0,
      backgroundColor: 'white',
      zIndex: 2,
      borderTop: '1px solid #e0e0e0',
    },
  },
  searchField: {
    sx: {
      minWidth: '300px',
      m: '0.5rem',
    },
  }
};

export const paginationProps = {
  rowsPerPageOptions: [10, 15, 20, 25, 30],
  showFirstButton: true,
  showLastButton: true,
  labelRowsPerPage: "Show",
  showRowsPerPage: true,
  variant: "outlined",
  shape: "rounded",
};